export const GET_PACKINGMATERIAL = "GET_PACKINGMATERIAL";
export const GET_PACKINGMATERIAL_UPDATE = "GET_PACKINGMATERIAL_UPDATE";
export const COPY_PACKINGMATERIAL = "COPY_PACKINGMATERIAL"